/**
 * Created by andrey on 12.02.2025
 */

const CloseRoundButton = cleverapps.UI.Button.extend({
    avoidNode: "CloseButton",

    ctor: function (options) {
        this.options = options;

        this.onClicked = options.onClicked || (() => {});

        this._super({
            type: {
                button_png: bundles.buttons_main.frames.window_close_round_png,
                button_on_png: bundles.buttons_main.frames.window_close_round_on_png
            },
            onClicked: () => {
                this.onClicked();
            },
            click_effect: undefined
        });

        this.setLocalZOrder(3);
        this.onResize();
    },

    // styles: false means the node declares ScaleComponent / AlignmentComponent itself - the prefab
    // path always does, so the button must not fight them (ScaleComponent keeps baseScale up to date)
    onResize: function () {
        if (this.options.styles === false) {
            return;
        }

        const styles = this.options.styles || cleverapps.styles.CloseRoundButton;

        this.baseScale = styles.scale[cleverapps.resolution.mode];
        this.setScale(this.baseScale);

        this.setAlignment(styles.position || styles);
    },

    hide: function () {
        this.setVisible(false);
    },

    show: function () {
        this.stopAllActions();
        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0, 0.3 * this.baseScale),
            new cc.Show(),
            new cc.ScaleTo(0.4, this.baseScale).easing(cc.easeBackOut())
        )).setFinalize(() => {
            this.setVisible(true);
            this.setScale(this.baseScale);
        });
    }
});

cleverapps.styles.CloseRoundButton = {
    scale: [0.8, 1, 1],

    x: { align: "right" },
    y: { align: "top", dy: -6 }
};